export default {"src":"/_next/static/media/property-news-logo.bd6e4d40.svg","height":33,"width":240,"blurWidth":0,"blurHeight":0};